import type { usePermissions } from 'Hooks'

export const hasPermission = (
  permissions: ReturnType<typeof usePermissions>,
  permissionCheck?: boolean,
): boolean => {
  return permissions.isLimitedUser ? !!permissionCheck : true
}
